<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
</div>
</td>

  <td>
    <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
    </div>
  </td>

</tr>
  </thead>
<tbody>
<tr>
  <td class="polish">

<p align="center" style="margin-top:20px;">
    <strong>UMOWA ZLECENIE nr {{ shortNrUmowy() }}</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p style="margin-bottom: 0px"><b>Zleceniodawcą:</b></p>
<p>
  <b>Tutore Poland Sp. z o.o.,</b> z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS: 0000670834, NIP: 727-28-12- 193, REGON: 366891567, kapitał zakładowy 3 329 200,00 zł  reprezentowaną przez <b>{{ zamawiajacy }}</b><span v-if="zamawiajacy.includes('Ewa Szcześniewska')"> działającą na podstawie pełnomocnictwa z dnia 07.12.2023 r., którego kopia stanowi zał. nr 6 do Umowy,</span>
</p>
<p>a</p>

  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  Pesel: {{pesel}}
  <br/>
  Adres: {{zamieszkany}}
  <br/>
  <br/>

  <p align="center" style="margin-top: 10px;"><strong>WARUNKI UMOWY</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p style="margin-bottom: 0px;">Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol>
  <li>rzetelne przygotowanie i prowadzenie zajęć zdalnych lub stacjonarnych dla wszystkich uczestników kursów organizowanych przez Zleceniodawcę zgodnie z programem edukacyjnym wskazanym przez Zleceniodawcę oraz harmonogramem zajęć (który może mieć formę zapisu elektronicznego); prowadzenie/animowanie zajęć interaktywnych.</li>
  <li>rzetelne prowadzenie dokumentacji potwierdzającej realizację zajęć, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą ewaluacji uczniów, sprawozdania z realizacji zajęć oraz raportów wymaganych przez Klientów B2B - w formie oraz terminach ustalonych przez Zleceniodawcę;</li>
  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
  <li>prowadzenie zajęć odrobieniowych;</li>
  <li>dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;</li>
  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę, przy czym Zleceniobiorca zobowiązany     jest do regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
    <ol type="a">
      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji;</li>
      <li>udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;</li>
    </ol>
  </li>
  <li>współpraca z kursantami lub w przypadku uczniów niepełnoletnich - ich rodzicami lub opiekunami prawnymi w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych, sprawdzanie i przekazywanie raportów z postępów uczniów) - udział w spotkaniach lub zebraniach, w określonych przez Zleceniodawcę terminach;</li>
  <li>inne zadania i projekty zlecone przez Zleceniodawcę.</li>
</ol>
<p>Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia aktualnie posiadanych materiałów dydaktycznych. Powyższe nie obejmuje sprzętu elektronicznego (komputer, sprzęt nagłaśniający, internet itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.</p>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 40px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się może online za pośrednictwem platform udostępnionych przez Zleceniodawcę, w formule stacjonarnej w wybranej placówce Zleceniodawcy, u Klienta lub w placówce wskazanej przez Zleceniodawcę. Forma prowadzenia zajęć określona zostanie w harmonogramie zajęć. Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform niezbędnych do prowadzenia zajęć.</li>
  <li>Strony ustalają, iż za jednostkę obliczeniową przyjmuje się 60 minut zajęć według ustalonego harmonogramu.</li>
  <li>Łączny wymiar godzin dydaktycznych do wykonania będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.</li>
  <li>Strony dopuszczają zmianę dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.</li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
  <li>Zleceniodawca za zgodą zleceniobiorcy dopuszcza możliwość zlecenia usług w stacjonarnej jednostce uzgodnionej przez obie strony.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Obowiązek informacyjny</strong>
</p>
  <ol>
    <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.</li>
    <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 4 Absencje i powiadamianie o nich</strong>
</p>
<ol>
  <li>W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.</li>
  <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia powiadomić o takiej sytuacji Zleceniodawcę.</li>
  <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia, jednak zobowiązany jest do poinformowania Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia. Zleceniobiorca potwierdza to, na podstawie e-zwolnienia lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE ZUS.</li>
  <li>W przypadku nieprzeprowadzenia zajęć w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5 000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za poniesione straty. Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia zajęć.</li>
  <li>W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu i niemożliwości znalezienia zastępstwa przez Zleceniodawcę, Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym zajęciom tzw. zajęcia odrobieniowe § 1 ust. 4, w innym terminie uzgodnionym pisemnie ze Zleceniodawcą.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
</p>
<ol>
  <li>Strony zawierają umowę od dnia {{ dataObowiazywaniaUmowyPolski() }} do dnia {{ umowaDo }} r.</li>
  <li>Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego paragrafu).</li>
  <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia w sytuacji braku możliwości powierzenia przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej umowy, przez co strony rozumieją w szczególności:
    <ol type="a">
      <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1 pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
      <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
      <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
      <li>wszelkie inne naruszenia niniejszej umowy.</li>
    </ol>
  </li>
  <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę finansową o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 6 Wynagrodzenie</strong>
</p>
<ol>
  <li v-if="stawka2 === ''">
    Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Zleceniobiorca otrzyma wynagrodzenie w wysokości: {{ stawka1 }} zł (słownie: {{ stawka1Slownie }} złotych) brutto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.</li>
  <li v-else-if="stawka2 !== ''">
    Z tytułu prawidłowego wykonania czynności wymienionych w § 1 Zleceniobiorca otrzyma wynagrodzenie
    brutto za jedną lekcję rozumianą zgodnie z § 2 ust. 3. w wysokości:
    <ol type="a">
      <li>
        usługa “{{ przedmiot1 }}” - {{ stawka1 }} zł (słownie: {{ stawka1Slownie }} złotych)
      </li>
      <li>
        usługa “{{ przedmiot2 }}” - {{ stawka2 }} zł (słownie: {{ stawka2Slownie }} złotych)
      </li>
      <li v-if="stawka3 !== ''">
        usługa “{{ przedmiot3 }}” - {{ stawka3 }} zł (słownie: {{ stawka3Slownie }} złotych)
      </li>
    </ol>
  </li>
  <li>W przypadku prowadzenia jako nauczyciel zajęć stacjonarnych w jednostkach oświatowych (żłobki, przedszkola, szkoły podstawowe, szkoły średnie, uczelnie wyższe) przysługuje dodatek  wysokości 10 zł brutto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.</li>
  <li>W przypadku prowadzenia jako animator zajęć stacjonarnych w jednostkach oświatowych (żłobki, przedszkola, szkoły podstawowe, szkoły średnie, uczelnie wyższe) stawka wynosi 31 zł brutto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.</li>
  <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, 15-tego dnia następnego miesiąca kalendarzowego następującego po miesiącu rozliczenia, w wysokości wynikającej ze stawki godzinowej oraz liczby godzin przepracowanych w danym miesiącu, w oparciu o zestawienie, o którym mowa w ust. 6 poniżej. na numer konta bankowego wskazanego przez Zleceniobiorcę.</li>
  <li>Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki godzinowej wynikającej z ust. 1-4 niniejszego paragrafu oraz liczby lekcji przeprowadzonych w danym miesiącu, w oparciu o zestawienie i dokumentację, o których mowa w ust. 6 niniejszego paragrafu. W przypadku, gdy jedna lekcja zgodnie z harmonogramem, trwa więcej bądź mniej niż 60 minut to stawka wynagrodzenia za jedną lekcję będzie proporcjonalnie obniżona bądź powiększona. Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie za dokonanie czynności dodatkowych związanych z przygotowaniem, organizacją i raportowaniem zajęć.</li>
  <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej:
    <ol type="a">
      <li>zestawienia liczby godzin przepracowanych w danym miesiącu, wygenerowanego z narzędzi do ewidencjonowania godzin udostępnionego przez Zleceniodawcę, najpóźniej w ostatnim dniu roboczym miesiąca.</li>
      <li>prowadzonej dokumentacji potwierdzającej realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów, najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu wykonania zlecenia.</li>
    </ol>
    Zweryfikowane przez Zleceniodawcę zestawienie i dokumentacja będą stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.
  </li>
  <li>Zleceniodawca może obniżyć o kwotę do 15% wysokości wynagrodzenia brutto za dany miesiąc, w przypadku niestosowania się do zapisów zawartych w umowie w szczególności: niedotrzymywania podanej dyspozycyjności, spóźniania się na zajęcia, nieodpisywania na e-maile oraz nie odbierania telefonów od osób wskazanych do kontaktu przez Zleceniodawcę, uzasadnionych skarg rodziców na jakość prowadzonych lekcji, niewywiązywania się z obowiązku oceniania dzieci w ramach raportów, nie zachowywania zasad kultury osobistej na zajęciach oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę, niewywiązywania się z wytycznych dotyczących programu i jakości prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę.</li>
  <li>Wyliczenie i wypłata premii następuje po upływie każdego miesiąca kalendarzowego (najpóźniej do 15-tego każdego miesiąca następującego po miesiącu rozliczeniowym).</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 7 Premia</strong>
</p>
<ol>
  <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w wysokości do 15% wynagrodzenia brutto, której przyznanie jest uzależnione od stopnia realizacji przydzielonych zadań indywidualnych. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
  <li>Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową za inne cele niezwiązane z ust. 1 niniejszego paragrafu.</li>
  <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
  <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 8 Informacje poufne</strong>
</p>
<ol>
  <li>Przez Informacje Poufne Strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy jego działalności i Klientów, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniodawcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.</li>
  <li>Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.</li>
  <li>Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.</li>
  <li>W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości         5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową.</li>
  <li>Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.</li>
  <li>Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.</li>
  <li>Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy przez okres 5 lat.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
      <strong>§ 9 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 10 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
  <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy.</li>
  <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych   (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 15px;">
  <strong>§ 11 Spory i sąd właściwy</strong>
</p>
<p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
  <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§ 13 Klauzula salwatoryjna</strong>
</p>
<p style="margin-bottom: 0px;">
  Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.
</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Prawo właściwe</strong>
</p>
<ol>
  <li>Niniejsza umowa podlega prawu polskiemu.</li>
  <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 20px;">
  <strong>§ 15 Liczba egzemplarzy umowy</strong>
</p>
<p>Niniejsza umowa została sporządzona w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze Stron.</p>
<br>

  <div>
    <p class="underline"><b>Załączniki stanowiące integralną część umowy:</b></p>
    <ol>
      <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
      <li class="underline">Informacja o monitoringu zajęć on - line</li>
      <li class="underline">Klauzula informacyjna Tutore Poland Sp. z o.o.</li>
      <li class="underline">Oświadczenie Zleceniobiorcy</li>
      <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
      
    </ol>
  </div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">Podpis Zleceniodawcy</span>
        <br>
        <span v-if="zamawiajacy.includes('Ewa Szcześniewska')" style="margin-left: 0%;">{{ zamawiajacy }}</span>
        <span v-else style="margin-left: 0%;">{{ zamawiajacy }}</span>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}
        <br>
        <span style="margin-left: 0%;">Podpis Zleceniobiorcy</span>
    </div>
</div>
<br>

<div style="margin-top:5px;page-break-before: always;">
  <p align="center"><b>Załącznik nr 1</b></p>
  <p align="center"><b>Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji papierowej i elektronicznej</b></p>
  <p class="p-margin">Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:</p>
  <p class="p-margin">z dniem podpisania upoważnienia przez obie strony upoważniam Pana/Panią {{ imieNazwisko }} – Zleceniobiorcę Tutore Poland Sp. z o.o. realizująca umowę zlecenie poprzez prowadzenie zajęć w dziale edukacji do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:</p>
  <p class="p-margin">w wersji elektronicznej:</p>
  <ol>
    <li>zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,</li>
    <li>zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland– imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,</li>
  </ol>
  <p>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.</p>
  <p>Niniejszy dokument nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.</p>
  <p>Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych.</p>
  <p>Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.</p>
  <p>Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.</p>
  <p>Niniejsze upoważnienie zostaje uchylone w dniu rozwiązania umowy zlecenie.</p>
</div>

<div class="container" style="page-break-before: always;">
  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
    <tr>
      <td id="oswiadczenie">
        <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
        <ol>
          <li>Ja niżej podpisany/a oświadczam, iż:
            <ol type="a">
              <li>
                zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
              </li>
              <li>
                treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
              </li>
              <li>
                zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
              </li>
              <li>
                zobowiązuję się do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
              </li>
              <li>
                zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
              </li>
            </ol>
          </li>
        </ol>
        <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{ imieNazwisko }}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
</div>

<div style="page-break-before: always;">
  <p align="center" class="subheading"><b>Załącznik nr 2</b></p>
  <p align="center" class="subheading" style="margin-bottom: 0px;"><b>Informacja o monitoringu zajęć on-line i nagrywaniu szkoleń wewnętrznych online</b></p>
  <p>Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on-line oraz nagrywania szkoleń wewnętrznych on-line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom.</p>
  <p>Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/ zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on-line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. </p>
  <p>Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć on-line składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie.</p>
  <p>Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on-line i w toku nagrywania szkoleń wewnętrznych on-line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.</p>
</div>

<div style="margin-top: 40px; font-size: 10px;">
  <p align="center" class="subheading"><b>Załącznik nr 3 Klauzula informacyjna Tutore Poland Sp. z o.o.</b></p>
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
    Łódź, dnia {{ aktualnaData() }} r.
  </p>
  <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
  <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
  <p align="center" class="subheading" style="margin-top: 100px;">
    <b>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</b>
  </p>
  <ol>
    <li>
      Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
    </li>
    <li>
      Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
    </li>
    <li>
      Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
    </li>
    <li>
      Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
      <ol type="a">
        <li>
          zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
        </li>
        <li>
          wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
        </li>
        <li>
          potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
        </li>
        <li>
          realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,
        </li>
        <li>
          realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
        </li>
        <li>
          realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
        </li>
        <li>
          bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
        </li>
        <li>
          zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
        </li>
      </ol>
    </li>
    <li>
      Odbiorcami Pani/Pana danych osobowych będą:
      <ul>
        <li>
          organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
        </li>
        <li>
          zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
        </li>
        <li>
          podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
        </li>
        <li>
          biura księgowe:
        </li>
        <li>
          banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
        </li>
        <li>
          kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy; 
        </li>
        <li>
          współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
        </li>
        <li>
          podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
        </li>
        <li>
          instytucje ubezpieczeniowe
        </li>
        <li>
          organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)
        </li>
        <li>
          podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
        </li>
      </ul>
    </li>
    <li>
      Ma Pani/Pan prawo do:
      <ol type="a">
        <li>
          <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
        </li>
        <li>
          <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
        </li>
        <li>
          <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
        </li>
        <li>
          <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
        </li>
        <li>
          <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
          <ol type="i">
            <li>
              kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
            </li>
            <li>
              przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
            </li>
            <li>
              Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
            </li>
            <li>
              wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
            </li>
          </ol>
        </li>
        <li>
          <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
        </li>
        <li>
          <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
        </li>
        <li>
          <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
          <ul>
            <li>
              pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
            </li>
            <li>
              elektronicznie za pośrednictwem platformy ePUAP.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <li>
      W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
    </li>
    <li>
      Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
    </li>
  </ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
            <li>Ja niżej podpisany/a oświadczam, iż:
              <ol type="a">
                <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
                <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
              </ol>
            </li>
            <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
            <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
            <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">{{imieNazwisko}}</span>
            <br>
            <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>

</td>

<td class="english">
  <p align="center" style="margin-top: 17px;">
    <b>MANDATE CONTRACT no. {{ shortNrUmowy() }}</b>
  </p>
  <p>
    executed in Łódź by and between:
  </p>
  <p><b>The Employer:</b></p>
  <p>
    <b>Tutore Poland Sp. z o.o.,</b> seated in Łódź at ul. Piotrkowska 157A, 90-440 Łódź, registered in the Entrepreneurs' Register of the National Court Registry held by the District Court for Łódź Śródmieście in Łódź, 20th Department of the National Court Registry under KRS number: 0000670834, NIP (tax ID): 727-28-12-193, REGON (statistical ID): 366891567, share capital PLN 3,329,000.00, represented by <b>{{ zamawiajacy }}</b><span v-if="zamawiajacy.includes('Ewa Szcześniewska')"> acting based on the power of attorney of 7 December 2023, whose copy has been attached as Appendix No. 6 hereto,</span>
  </p>
  <p>and</p>

  <b>the Contractor:</b>
  <br/>
  Name: {{ imieNazwisko }}
  <br/>
  PESEL (personal ID no.): {{ pesel }}
  <br/>
  Address: {{ zamieszkany }}
  <br/>
  <br/>

  <p align="center"><b>TERMS OF AGREEMENT</b></p>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 1 Subject of the Agreement</b>
</p>
<p style="margin-bottom: 0px;">
  The Employer shall commission, and the Contractor shall perform, for a fee, such activities as:
  <ol>
    <li>diligent preparation and conducting remote or stationary classes for all participants of courses organised by the Employer per the curriculum indicated by the Employer and the classes' schedule (which may be in an electronic format); conducting/animating interactive classes.</li>
    <li>diligent keeping of documentation confirming the conducting of classes, including in particular: class logs, attendance lists, documentation regarding the students' evaluation, reports on classes and reports required by B2B customers - in the form and till deadlines set by the Employer;</li>
    <li>timely implementation of all Employer's organisational guidelines within the specified deadlines;</li>
    <li>conducting rescheduled classes;</li>
    <li>taking care of the proper condition of the Employer's property, order and tidiness at the place where the job is performed;</li>
    <li>cooperation with persons designated by the Employer. The Contractor shall regularly and immediately (at the end of each working day at the latest) read messages sent by these persons via email, text messages or instant messengers and, if necessary, respond to them as soon as possible, including in particular:
      <ol type="a">
        <li>providing the necessary information to the extent specified in a given situation;</li>
        <li>participation in meetings, inspection talks and evaluations;</li>
      </ol>
    </li>
    <li>cooperation with students or their parents or legal guardians in the case of minor students, including in particular providing the necessary information regarding the service (e.g. informing about homework, checking and submitting reports on students' progress) - participation in meetings on the dates specified by the Employer;</li>
    <li>other tasks and projects commissioned by the Employer.</li>
  </ol>
</p>
<p>In order to ensure the conditions for the performance hereof, the Employer shall make all currently possessed teaching materials available. The above shall not include electronic hardware (computers, sound equipment, the Internet, etc.), which the Contractor shall arrange at their own expense.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2 Contract Performance</strong>
</p>
<ol>
  <li>The Contractor shall perform the subject hereof with due diligence.</li>
  <li>The subject of the contract referred to in § 1 may be performed online via platforms provided by the Employer, in the stationary form at the selected Employer's branch, at the Client's, or at a facility indicated by the Employer. The form of classes shall be defined in the schedule. The Employer shall make the platforms necessary to run classes available to the Contractor.</li>
  <li>The parties have agreed that the calculation unit shall be 60 minutes of classes per the agreed schedule.</li>
  <li>The Employer shall, in advance, define the total amount of teaching hours in the schedule and sum it up at the end of each calendar month.</li>
  <li>The parties may change the dates and times of classes defined in the schedule only upon their mutual consent.</li>
  <li>The Contractor shall render the services hereunder being entirely independent of the Employer. In particular, the Employer shall not have any managerial rights towards the Contractor or interfere in the Contractor's organisation or discipline of work. The Parties shall solve any technical or methodological issues regarding the activities commissioned to the Contractor by mutual agreement, respecting the professional independence of the Contractor's business.</li>
  <li>The Contractor shall not subcontract the performance of the subject matter hereof to any third party.</li>
  <li>Upon the Contractor's consent, the Employer may order services in a stationary unit agreed upon by both parties.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Information obligation</strong>
</p>
  <ol>
    <li>The Employer shall provide the Contractor with all information necessary to perform the contract.</li>
    <li>The Contractor shall provide the Employer with necessary information on the performance of the contract.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 4 Absence and its notification</strong>
</p>
<ol>
  <li>If the classes referred to in §1 cannot be conducted on the scheduled dates due to any reasons on the Contractor's part, the Contractor shall immediately notify the Employer about it, yet seven days before the scheduled date at the latest. In such a case, the Employer may designate a person who shall substitute the Contractor to perform the order referred to herein.</li>
  <li>In the case of sudden indisposition due to illness or poor health, the Contractor may not keep the seven-day period to notify about the inability to perform the order. The Contractor shall immediately notify the Employer about the occurrence of such an event, yet within 4 hours at the latest.</li>
  <li>In the case of sudden indisposition due to illness or poor health, the Contractor may not keep the seven-day period to notify about the inability to perform the order; however, they shall advise the Employer immediately after such an event has occurred. The Contractor shall confirm that based on medical leave transferred to the Employer's account with PUE ZUS.</li>
  <li>If the classes are not conducted as scheduled, and the Employer is not notified about that seven days before the scheduled date at the latest, the Employer may terminate the contract with immediate effect without the notice period. In such a case, notwithstanding the termination option, the Employer may additionally claim a contractual penalty of PLN 5,000 (five thousand zlotys) from the Contractor for incurred losses. The Employer may pursue compensation exceeding the contractual penalty's amount. This provision shall not apply to any acts of God which prevent notifying the Employer about the inability to conduct the classes.</li>
  <li>If the Contractor cannot conduct scheduled classes and the Employer cannot find a substitute contractor, the Contractor shall teach classes in the same number of hours as the missed classes, so-called rescheduled classes §1(4), on another date agreed with the Employer.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 5 Contract term and notice period</strong>
</p>
<ol>
  <li>This contract shall be effective from {{ dataObowiazywaniaUmowyAngielski() }} to {{ umowaDo }}.</li>
  <li>The Parties may terminate the contract upon one-month notice effective at the end of the following calendar month after sending a written termination notice (subject to section 3 of this paragraph).</li>
  <li>The Employer may terminate the contract without notice period if the subject matter hereof cannot be entrusted or if the Contractor gravely objects to the provisions hereof, which the Parties shall understand as particularly:
    <ol type="a">
      <li>Contractor's non-performance of the obligations laid down in §1, despite being previously requested by the Employer to cease the breach,</li>
      <li>Contractor's breach of the non-competition clause,</li>
      <li>Contractor's disclosure of Confidential Information,</li>
      <li>any other breaches hereof.</li>
    </ol>
  </li>
  <li>Should the contract be terminated, the Contractor shall return all materials provided for the term hereof by the Employer within 14 days from the termination or expiry hereof. Should the Contractor fail to return the materials within the time, the Employer may impose a financial penalty upon the Contractor equal to the value of the received materials. Additionally, the Contractor may be charged with shipment costs.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 50px;">
  <strong>§ 6 Remuneration</strong>
  </p>
<ol>
  <li v-if="stawka2 === ''">
    For the proper performance of the activities referred to in §1, the Contractor shall be paid in the amount: {{ stawka1 }} PLN ({{ slownieAngielski(stawka1) }} zlotys) gross for one class in the meaning of §2 sect. 3</li>
  <li v-else-if="stawka2 !== ''">
    For the proper performance of the activities referred to in §1, the Contractor shall be paid gross remuneration for one class in the meaning of §2 sect. 3 in the amount:
    <ol type="a">
      <li>
        service “{{ przedmiot1 }}” - {{ stawka1 }} PLN ({{ slownieAngielski(stawka1) }} zlotys)
      </li>
      <li>
        service “{{ przedmiot2 }}” - {{ stawka2 }} PLN ({{ slownieAngielski(stawka2) }} zlotys)
      </li>
      <li v-if="stawka3 !== ''">
        service “{{ przedmiot3 }}” - {{ stawka3 }} PLN ({{ slownieAngielski(stawka3) }} zlotys)
      </li>
    </ol>
  </li>
  <li>In the case of classes conducted as a stationary class teacher in educational facilities (crèches, kindergartens, primary and secondary schools, universities), an allowance of PLN 10 gross shall be due for one class in the meaning of §2 sect. 3.</li>
  <li>In the case of classes conducted as a stationary class animator in educational facilities (crèches, kindergartens, primary and secondary schools, universities), the rate shall be PLN 30 gross for one class in the meaning of §2 sect. 3.</li>
  <li>Remuneration for each month of the order shall be paid in arrears by the 15th day of the calendar month following the settlement month, in the amount resulting from the hourly rate and the number of hours worked in the month, based on a statement referred to in sect. 6 below, to the bank account provided by the Contractor.</li>
  <li>The total monthly remuneration shall result from the hourly rate set forth in sect. 1-4  of this paragraph and the number of classes conducted in the month, based on the statement and documentation referred to in sect. 6 of this paragraph. If a single scheduled class lasts more or less than 60 minutes, the fee for one class shall be pro-rata increased or decreased. The Contractor shall not be entitled to additional remuneration for extra activities related to the preparation, organisation and reporting classes.</li>
  <li>The Contractor shall draw up and deliver in electronic format to the Employer
    <ol type="a">
      <li>a statement of the number of hours worked in the month generated from the hours registration tool made available by the Employer, on the last business day of the month at the latest.</li>
      <li>documentation which confirms conducting the classes in the month, in particular, class logs and students' attendance lists by the last day of the month for which remuneration is due to the Contractor for completing the order.</li>
    </ol>
    The verified statement and documentation shall be the basis for paying remuneration to the Contractor.
  </li>
  <li>The Contractor may reduce by 15% of the gross remuneration for the month if the Contractor fails to adhere to the provisions hereof, in particular not being available as declared, being late for classes, not replying to emails and not answering phone calls from persons nominated to contacts by the Employer, reasonable parents' complains regarding the quality of classes, not assessing children within the reports, not keeping personal culture during classes and in contacts with individuals designated by the Employer, not fulfilling the guidelines regarding the curriculum and quality of the educational classes determined by the Employer.</li>
  <li>Bonuses shall be calculated and paid after each calendar month (by the 15th day of each month following the settlement month).</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 25px;">
  <strong>§ 7 Bonus</strong>
</p>
<ol>
  <li>The Employer may grant the Contractor a discretionary bonus of up to 15% of the gross remuneration, which shall depend on the completion level of individual tasks allocated. Individual tasks for the next month shall be presented in due advance.</li>
  <li>Additionally, the Employer may grant an extra discretionary bonus for other goals unrelated to sect. 1 of this paragraph.</li>
  <li>The bonus shall not be of claimable nature, and its granting and amount shall be at the Employer's discretion.</li>
  <li>The bonus shall be calculated and paid within 15 days from the end of the monthly settlement period.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 8 Confidential information</strong>
</p>
<ol>
  <li>The Parties shall understand Confidential Information as any information disclosed by the Employer to the Contractor or obtained by the Contractor in any other way following the performance hereof, including technical, technological, organisational or other information of economic value which regards the Employer's operations and Clients. It shall, in particular, include the didactic materials used by the Employer, a database of the Employer's Clients' contact details (including clients who have ended their cooperation with the Employer up to 12 months after the respective contract ended), computer systems and other information obtained from the Employer during the term hereof.</li>
  <li>The Contractor shall keep all Confidential Information obtained hereunder secret and use it only to perform the contract. The Confidential Information shall not be used to any other end and disclosed or made available to any third parties, in part or entirety. The confidentiality obligation shall regard the Confidential Information obtained by the Contractor from the Employer in writing and disclosed to the Contractor orally, visually, electronically or in any other way. The contract shall keep the obtained Confidential Information secret and not disclose it to anyone without the Employer's written consent.</li>
  <li>Once the Parties' cooperation has ended or earlier at each Employer's request, the Contractor shall return all Confidential Information within three days together with documentation and other media on which it is stored and copies of such documentation and media with the Confidential Information. The Contractor shall delete all received or developed materials from computer memory and other devices so that they cannot be recovered and used in the future in any form.</li>
  <li>Should the Contractor breach the provisions of the preceding sections, particularly by disclosing or making available materials or Confidential Information contrary hereto, the Contractor shall pay the Employer a contractual penalty of PLN 5,000 (five thousand zlotys) for each breach. The penalty shall be paid within 14 days of the Employer's submitting information on charging the Contractor with the penalty.</li>
  <li>If the Employer's damage or lost benefits caused by the Contractor's breach of the provisions hereof is in excess of the contractual penalty referred to in section 4 of this paragraph, the Employer may claim supplementary damages upon general terms under the Civil Code.</li>
  <li>The Employer shall also deem a breach hereof any use of their didactic materials for the Contractor's private purposes or to teach individuals who are not Employer's Clients.</li>
  <li>Notwithstanding the expiry or termination hereof, the Contractor's confidentiality obligation shall remain in force for five years.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 9 Non-competition clause</strong>
</p>
  <ol>
    <li>Competitive operations in the meaning of this paragraph shall be the Contractor's offering or rendering educational services in any form to Employer's Client, who signed a contract with the Employer on the termination date hereof at the latest.</li>
    <li>The following shall also be deemed competitive activity:
      <ol type="a">
        <li>Contractor's services to any entity running business competitive to that of the Employer's, Contractor's providing services based on any civil law contract to any entity running business competitive to that of the Employer's.</li>
        <li>the Contractor running a business, including via a third party, whose operations are competitive to that of the Employer,</li>
        <li>being a partner to a company which runs a business competitive to that of the Employer,</li>
        <li>the Contractor being a member of managing authorities in entities which run business competitive to that of the Employer,</li>
        <li>acting in the capacity of an agent, attorney or proxy of entities which run business competitive to that of the Employer.</li>
      </ol>
    </li>
    <li>During the term hereof, the Contractor shall not run any operations competitive to that of the Employer per the definition set forth in section 1 of this paragraph.</li>
    <li>If a Client who is a current Employer's Client makes a cooperation offer to the Contractor, the Contractor shall inform the Client about being bound by the non-competition clause, obligation to refuse. They shall also notify the Employer about the situation.</li>
    <li>The Employer reserves the right to verify whether the Contractor duly follows the provisions of this paragraph.</li>
    <li>The Employer may impose a penalty of PLN 20,000 (twenty thousand zlotys) on the Contractor for each breach of the non-competition clause. In such a case, the Employer may also pursue compensation exceeding the contractual penalty's amount.</li>  
  </ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 30px;">
  <strong>§ 10 Service and correspondence, consent to using the image, GDPR</strong>
</p>
<ol>
  <li>The Parties have agreed that unless they notify about a change of their mailing addresses, any correspondence sent to the addresses provided in the Parties' description shall be deemed served on the date of the second advice note.</li>
  <li>The Parties' email addresses have been provided in the Parties' description. A letter sent by email shall be deemed served when the other party has the opportunity to read it.</li>
  <li>The Contractor consents to their image being used per the respective schedule hereto.</li>
  <li>The Contractor shall observe Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (GDPR) (consolidated text in the Journal of Laws of 2019, item 1781, as amended) The Contractor consents to the processing of their personal data per the information clause which constitutes a schedule hereto.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 15px;">
  <strong>§ 11 Disputes and court jurisdiction</strong>
</p>
<p>The Parties declare they shall make every effort to solve any disputes hereunder amicably. If a dispute cannot be amicably solved within 14 days of requesting the other party in writing to solve it, it shall be referred to the court with jurisdiction over the Employer's seat.</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 12 Full contract and its amendment</strong>
</p>
<ol>
  <li>This contract dissolves and replaces any previous written or oral arrangements, agreements and contracts between the Parties within its scope, which shall hereby lose their legal force.</li>
  <li>The Parties declare that, apart from this contract, there are no additional arrangements or agreements regarding the subject matter hereof.</li>
  <li>Any amendments hereto shall be made in writing, otherwise being null and void.</li>
  <li>This contract shall only be solved in writing under pain of nullity.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 13 Severability clause</strong>
</p>
<p>
  If any provision hereof turns invalid in whole or part, the other provisions shall remain in force. Upon a request from any of the Parties, they shall replace invalid provisions with ones whose legal force and economic effect shall be closest to the replaced regulations.
</p>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 14 Governing law</strong>
</p>
<ol>
  <li>This agreement shall be governed by the laws of Poland.</li>
  <li>In any matters not stipulated herein, respective provisions of law shall apply, particularly those of the Civil Code.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 15 Counterparts</strong>
</p>
<p>
  This contract has been drawn up in two identical counterparts, one for each of the Parties.
</p>
<br>

 <div>
  <p class="underline"><b>The following Appendices constitute an integral part hereof:</b></p>
  <ol>
    <li class="underline">Authorisation to process personal data</li>
    <li class="underline">Information on monitoring online classes</li>
    <li class="underline">Tutore Poland Sp. z o.o. information clause</li>
    <li class="underline">Contractor's declaration</li>
    <li class="underline">General OHS rules for administrative and office work</li>
    <li v-if="zamawiajacy.includes('Ewa Szcześniewska')" class="underline">A copy of the power of attorney</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">Signature of the Principal</span>
        <br>
        <span v-if="zamawiajacy.includes('Ewa Szcześniewska')" style="margin-left: 0%;">Ewa Szcześniewska - attorney</span>
        <span v-else style="margin-left: 0%;">{{ zamawiajacy }}</span>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}
        <br>
        <span style="margin-left: 0%;">Signature of the Contractor</span>
    </div>
</div>
<br>

<div style="page-break-before: always;"></div>

<div style="margin-top:5px;page-break-before: always;">
  <p align="center"><b>Appendix No. 1</b></p>
  <p align="center"><b>Authorisation to process personal data in a paper and electronic set</b></p>
  <p class="p-margin">Pursuant to Article 29 of Regulation of the European Parliament and the Council (EU) 2016/679 of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (general regulation on data protection), hereinafter referred to as "GDPR",</p>
  <p class="p-margin">on the date when both parties sign this authorisation I authorise Mr/Ms {{ imieNazwisko }} - the contractor of Tutore Poland Sp. z o.o. who runs classes within the educational department to process personal data included in the following data sets:</p>
  <p class="p-margin">In the electronic version:</p>
  <ol>
    <li>a set of Clients' personal data: parents (legal guardians) of children, adolescents and adults using the Tutore Poland services - name and surname, address, contact telephone number, e-mail address,</li>
    <li>a set of Clients' personal data: children, adolescents and adults using the Tutore Poland services - name and surname, address, contact telephone number, and e-mail address,</li>
  </ol>
  <p>for entering, modifying, deleting and archiving personal data covered by the above-mentioned sets.</p>
  <p>This document does not authorise granting further authorisations and shall expire on the mandate contract termination date and may be changed or revoked at any time.</p>
  <p>I oblige you to process the personal data contained in the above-mentioned personal data sets to the extent and in the manner required to fulfil official duties towards the Employer - Personal Data Controller.</p>
  <p>I oblige you to process personal data per the authorisation granted, Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (OJ L 119, p. 1) and the provisions of the Act of 10 May 2018 on the protection of personal data (Journal of Laws of 2018, item 1000), and applicable in Tutore Poland Sp. z o. o. internal regulations on the protection of personal data.</p>
  <p>Any violation of the above obligations may result in incurring criminal liability and shall constitute the basis for termination of the mandate contract.</p>
  <p>This authorisation is revoked on the mandate contract termination date.</p>
</div>

<div class="container" style="page-break-before: always;">
  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
    <tr>
      <td id="oswiadczenie">
        <p align="center" class="subheading"><strong>CONTRACTOR'S DECLARATION</strong></p>
        <ol>
          <li>I, the undersigned, declare that:
            <ol type="a">
              <li>
                I have read and accepted the content and scope of the authorisation,
              </li>
              <li>
                the authorisation content is comprehensible and clear to me, and all doubts have thoroughly been explained to me by the authorised person,
              </li>
              <li>
                I shall process the personal data contained in the above-mentioned personal data sets to the extent and in the manner required to fulfil official duties towards the Employer,
              </li>
              <li>
                I shall process personal data per the authorisation granted, the GDPR provisions, and the internal procedures in force at the Employer, including the Privacy Policy,
              </li>
              <li>
                I shall keep secret the personal data to which I have or will have access in connection with the performance of my duties for Tutore Poland Sp. z o.o. and the methods of securing personal data, also after revoking or changing the authorisation, also after the contract term.
              </li>
            </ol>
          </li>
        </ol>
        <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{ aktualnaData() }} {{ imieNazwisko }}</span>
          <br>
          <span>Date and signature of the Contractor</span>
        </div>
      </td>
    </tr>
  </table>
</div>

<div style="page-break-before: always;">
  <p align="center" class="subheading"><b>Appendix No. 2</b></p>
  <p align="center" class="subheading" style="margin-bottom: 0px;"><b>Information on monitoring online classes and recording internal online training</b></p>
  <p>Please be advised that Tutore Poland Sp. z o. o. uses technical means to monitor online classes and record internal online training. The monitoring covers the user's video and sound recording devices for conducting online classes, i.e. the Clickmeeting platform or the Zoom application, and in the case of internal online training, the Zoom application.</p>
  <p>Tutore Poland Sp. z o.o. monitors for the following purposes: ensuring the highest standards of service of classes carried out by employees/contractors, correct performance of entrusted activities and possible improvement of the classes' quality, securing the company's interests in disputes with the client (evidence), and in the case of internal online training to ensure the recordings' availability for new employees/contractors.</p>
  <p>Please be advised that the audiovisual and sound monitoring system for online classes consists of a system recording the Clickmeeting or Zoom platforms and a server on which online classes are recorded. The recordings of online classes can be accessed by persons authorised by the Tutore Poland Sp. z o.o. Board of Directors, i.e. Call Centre Department Manager, Process Management Director, Helpline Department Teamleader. The individuals with access to the recorded image are aware of the liability for protecting personal data and hold the appropriate authorisation issued by the Personal Data Controller. In the course of the recording, personal data are processed in the form of voice, image and name and surname of the employee/contractor conducting the classes or training.</p>
  <p>Tutore Poland Sp. z o.o. is the controller of personal data obtained within monitoring online classes and recording internal online training. In connection with the above-described activity, the company has included below the required information clause regarding the processing of personal data.</p>
</div>

<div style="margin-top: 40px; font-size: 10px;">
  <p align="center" class="subheading"><b>Appendix No. 3 Tutore Poland Sp. z o.o. information clause</b></p>
  <p align="right" style="font-size: 14px; margin-bottom: 0;">
    Łódź, date {{ aktualnaData() }}
  </p>
  <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
  <p style="font-size: 14px;">Contractor's name </p>
<p align="center" class="subheading">
  <strong>INFORMATION ON THE PERSONAL DATA PROCESSING</strong>
</p>
<ol>
  <li>
    Please be advised that the controller of your personal data as the Contractor is Tutore Poland Sp. z o. o. with its registered office at ul. Piotrkowska 157A, 90-440 Łódź, National Court Registry: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
  </li>
  <li>
    By presenting you with this information on personal data protection, the Controller satisfies the legal obligation under Article 15(1) of Regulation of the European Parliament and the Council (EU) 2016/679 of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (general regulation on data protection), hereinafter referred to as GDPR,
  </li>
  <li>
    The controller obtains information about you in connection with the statutory obligation, which is necessary to implement the cooperation process effectively. Wherever the scope of data goes beyond the statutory requirements - their provision is voluntary.
  </li>
  <li>
    Your personal data shall be processed for the following purposes, on the following basis and for the following period:
    <ol type="a">
      <li>
        conclusion and execution of a civil law contract - in order to comply with the obligation under the Civil Code (Article 6(1)(b), (c), (f) GDPR) - for the period of cooperation,
      </li>
      <li>
        calculation and payment of remuneration - in order to comply with the obligation under the Civil Code (Article 6(1)(c), Article 9(2)(b) GDPR) - for the period of cooperation,
      </li>
      <li>
       salary deductions - in order to comply with salary enforcement obligations under the Civil Procedure Code, the Administrative Enforcement Proceedings Act, and the Bailiffs Act (Article 6(1)(c) of the DPA) - for the period prescribed by generally applicable law,
      </li>
      <li>
        fulfilment of tax obligations - in order to fulfil the obligations of an income tax payer under the Tax Ordinance, the Personal Income Tax Act and other tax regulations (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the calendar year,
      </li>
      <li>
        fulfilment of obligations towards the Social Insurance Institution (ZUS) - in order to fulfil obligations of a payer of social and health insurance contributions resulting from the Act on pensions from the Social Insurance Fund, the Act on the social insurance system and the Act on healthcare benefits financed from public funds (Article 6(1)(c), Article 9(2)(b) GDPR) - for a period of 5 years from the end of the calendar year,
      </li>
      <li>
        fulfilment of accounting obligations - in order to fulfil obligations under the Accounting Act, the Tax Code and the Corporate Income Tax Act (Article 6(1)(c) GDPR) - for a period of 5 years from the end of the accounting year in which the event occurred,
      </li>
      <li>
        physical security of the Administrator's buildings, premises and property - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) - for the period of cooperation,
      </li>
      <li>
        to ensure the highest standards of service of the lessons provided by the Collaborators via the ClickMeeting or Zoom platform, the correctness of the performance of the entrusted activities and the possible improvement of the quality of the lessons, safeguarding the interests of the company in situations of disputes with the client (evidence) by monitoring and recording online courses - based on the voluntary consent of the recorded person (Article 6(1)(a) GDPR) - the Image and voice of the Collaborator will be processed for a period of 3 months. Where the recordings of the recorded classes constitute evidence in proceedings under the law or the Administrator has become aware that they may constitute evidence in the proceedings, this period shall be extended until the proceedings have become final. After the expiry of these periods, the recordings containing personal data shall be destroyed,
      </li>
      <li>
        to ensure that recordings can be made available to new Employees and Associates by recording online training sessions conducted using the Zoom platform - based on the voluntary consent of the person being recorded (Article 6(1)(a) of the GDPR) - the Image and voice of the Associate will be processed until the consent is withdrawn. If consent is withdrawn, recordings containing personal data shall be destroyed,
      </li>
      <li>
        to ensure the highest standards of customer service quality, for training purposes - enabling the improvement of service quality, to safeguard the company's interests in situations of disputes with customers (evidence), to ensure the safety of Co-workers in the event of undesirable and dangerous events on the part of customers (e.g. criminal threats) by monitoring telephone conversations with the Administrator's customers - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) - for a period of up to 3 months. Where the recordings of the recorded telephone conversations constitute evidence in a proceeding conducted on the basis of legal regulations or the Administrator has become aware that they may constitute evidence in the proceeding, this period is extended until the proceeding is legally concluded. After the expiry of these periods, recordings containing personal data shall be destroyed,
      </li>
      <li>
        creating photo-reports from camps for children and young people on a memory stick for Customers, facebook fanpage and the website www.musicandmore.pl - based on the voluntary consent of the recorded person (Article 6(1)(a) GDPR) - the image and voice of the Co-worker will be processed until the consent is withdrawn. If consent is withdrawn, recordings containing personal data shall be destroyed,
      </li>
      <li>
        pursuing claims or defending against claims - based on the Administrator's legitimate interest (Article 6(1)(f) GDPR) consisting in appearing in court cases - in the case of pending proceedings, for the duration of the proceedings until their final conclusion and for the period determined by generally applicable laws.
      </li>
    </ol>
  </li>
  <li>
    The recipients of your personal data will be:
    <ul>
      <li>
        public administration authorities (e.g. Social Insurance Institution, Tax Offices) - by virtue of the relevant legislation;
      </li>
      <li>
        Health care facilities for occupational health purposes;
      </li>
      <li>
        external entities providing and supporting the Employer's ICT systems (both general ICT infrastructure, electronic mail and IT systems used by the Employer for HR and financial services or circulation of documents related to employment) - by virtue of relevant personal data processing entrustment agreements and ensuring that the above entities apply adequate technical and organisational measures to ensure data protection,
      </li>
      <li>
        accounting offices:
      </li>
      <li>
        banks - for the purpose of payment of salaries and other monetary benefits to the Principal in case of their payment with the consent of the Contractor to a bank account;
      </li>
      <li>
        contractors - for the purpose of enabling contractors (potential and current) to contact them or for the day-to-day execution of contracts concluded and related to the Contractor's position; 
      </li>
      <li>
        co-workers of the Contractor, who provide services to Tutore Poland Sp. z o.o., to enable the co-workers to contact the Contractor,
      </li>
      <li>
        entities providing additional services to the Contractors, only if the Contractor uses these services.
      </li>
      <li>
        insurance institutions
      </li>
      <li>
        foreign administration organisations in the EU countries where the contract is performed (applies to the performance of the contract abroad)
      </li>
      <li>
        entities providing training and performing health and safety duties (if there is no health and safety unit at the Contractor's premises).
      </li>
    </ul>
  </li>
  <li>
    You have the right to:
    <ol type="a">
      <li>
        <strong>Access to data</strong> — to obtain confirmation from the Administrator as to whether your personal data are being processed. If data is being processed, you are entitled to access the data (Article 15 GDPR);
      </li>
      <li>
        <strong>to obtain a copy of the data</strong> — to obtain a copy of the data being processed, the first copy is free of charge and for subsequent copies, the relevant Controller may charge a reasonable fee based on administrative costs (Article 15(3) GDPR);
      </li>
      <li>
        <strong>rectification</strong> — request the rectification of personal data that is inaccurate or the completion of incomplete data (Article 16 GDPR);
      </li>
      <li>
        <strong>erasure</strong> — request the erasure of personal data where the Controller no longer has a legal basis for the processing or the data are no longer necessary for the purposes of the processing (Article 17 GDPR);
      </li>
      <li>
        <strong>restriction of processing</strong> — request the restriction of the processing of personal data (Art. 18 GDPR) when:
        <ol type="i">
          <li>
            you contest the accuracy of the personal data - for a period allowing the Administrator to verify the accuracy of the data,
          </li>
          <li>
            the processing is unlawful, and you object to the erasure of the data by requesting the restriction of its use,
          </li>
          <li>
            The Administrator no longer needs the data, but it is for you to establish, assert or defend your claims;
          </li>
          <li>
            you have lodged an objection to the processing - until it is determined whether the legitimate grounds on the part of the Administrator override the grounds for your objection;
          </li>
        </ol>
      </li>
      <li>
        <strong>data portability</strong> — to receive in a structured, commonly used machine-readable format the personal data concerning you provided to the Controller, and to request that this data be sent to another Controller where the data is processed on the basis of your consent, or a contract concluded with you, and where the data is processed by automated means (Article 20 GDPR);
      </li>
      <li>
        <strong>objection</strong> — to object to the processing of personal data for the legitimate purposes of the Controller, on grounds related to your particular situation, including profiling. The Controller shall assess the existence of valid legitimate grounds for the processing, overriding your interests, rights and freedoms or grounds for establishing, pursuing or defending claims. If according to the assessment, your interests outweigh the interests of the Controller, the Controller will be obliged to stop processing the data for these purposes (Article 21 GDPR);
      </li>
      <li>
        <strong>the right to lodge a complaint with the supervisory authority</strong> – the President of the Office for the Protection of Personal Data, if you consider that the processing of personal data concerning you is in breach of the law. Complaints can be submitted in the form of:
        <ul>
          <li>
            in writing to the address: 2 Stawki Street, 00-193 Warsaw,
          </li>
          <li>
            electronically via the ePUAP platform.
          </li>
        </ul>
      </li>
    </ol>
  </li>
  <li>
    The processing of personal data shall not include solely automated decision-making or profiling referred to in GDPR Article 22(1)(4). That means no decisions shall be made automatically, and no profiles shall be created concerning you.
  </li>
  <li>
    You are obliged to inform the Employer about any changes regarding your personal data provided to them per the Agreement.
  </li>
</ol>
</div>

<div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>CONTRACTOR'S DECLARATION</strong></p>
          <ol>
            <li>I, the undersigned, declare that:
              <ol type="a">
                <li>I have read and accepted the Information on the monitoring of online classes and the recording of internal online training as well as the Information Clause,</li>
                <li>the Information and Clause content is comprehensible and clear to me, and all doubts have thoroughly been explained to me by the authorised person,</li>
              </ol>
            </li>
            <li>I voluntarily consent to the processing of my personal data for the purposes referred to in the Information on monitoring online classes and recording internal online training.</li>
            <li>I have been advised that my personal data shall be processed based on my voluntary consent and that I have the right to withdraw it at any time. The withdrawal of consent shall have legal effects from the moment of its submission. It shall not affect the processing of my personal data for purposes related to implementing the study before submitting a declaration of consent withdrawal.</li>
            <li>Pursuant to Art. 81(1) of the Act on Copyright and Related Rights, I consent to my image's dissemination by Tutore Poland Sp. z o. o. for the purposes referred to in the Information on the monitoring of online classes and recording internal online training.</li>
          </ol>
          <div style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">{{ imieNazwisko }}</span>
            <br>
            <span>Contractor's signature</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>

</td>
</tr>

</tbody></table>

<div style="margin-top:5px;page-break-before: always;">
  <p><b>Załącznik nr 4 / Appendix no 4</b></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy/ Contractor's declaration</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE / PERSONAL DATA</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA / FILL IN</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data / Date</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko/ Name(s) and surname </span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL/ PESEL (Personal ID) number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)/ Identity card number (please provide if there is no PESEL number)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo / Nationality</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

    <tr v-if="obywatelstwoOIZ">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>A. Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych*): / I have a center of personal or economic interest (center of vital interests) in the territory of the Republic of Poland:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoOIZ}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoDNI">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>B. Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym): / I reside in the territory of the Republic of Poland for more than 183 days in a calendar (tax) year:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoDNI}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu / Telephone number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail / E-mail address</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres zamieszkania</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
    <br>
    <span>Address</span>
    <br>
    <span class="caption"> (street, house number, postal code, city)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres korespondencyjny</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
    <br>
    <span>Mailing address</span>
    <br>
    <span class="caption"> (street, house number, postal code, city)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Urząd Skarbowy</span>
    <br>
    <span>(zgodny z adresem zamieszkania)</span>
    <br>
    <span>Tax office</span>
    <br>
    <span>(according to the residence address)</span>
    </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego / Bank account number</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE: / I DECLARE THAT:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany) / ANSWERS "YES" OR "NO"<br>(or description if required)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem / I'm retired</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą / I am a disabled pensioner</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu Niepełnosprawności / I have a disability level decision</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności / If "YES", please specify the degree of disability</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych): / I am a student under the age of 26 (does not apply to doctoral, postgraduate studies):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym): / I apply for voluntary sickness insurance (only in case of compulsory pension and disability insurance coverage):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie (Jeśli wpisano "TAK", proszę uzupełnić poniższe dane) / I am employed under an employment contract I am employed on the basis of an employment contract or a mandate contract (If "YES", please complete the details below) / I am employed under an employment contract</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6): / Name and address of employer/principal other than Tutore Poland Sp. z o.o. (please complete it in case of answering YES in point 6):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland jest wyższe bądź równe krajowej płacy minimalnej: / The remuneration from employment contract/ order contract in another place than Tutore Poland is higher or equal to the national minimum wage:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

    <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3 Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2): / I apply for voluntary pension and disability insurance (only in case of answering YES in point 6 and 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wniosekUbezpieczenie.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza): / I am subject to social insurance from a title other than a order contract with Tutore Poland Sp. z o.o. (e.g. maternity benefit, parental benefit, parental leave, own non-agricultural economic activity):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia / If YES, please specify the insurance title</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

<tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
    <p class="cell-in-first-table oswiadczenie-footer">
      <strong>
      Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Poland Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
      </strong>
    </p>
    <p class="cell-in-first-table oswiadczenie-footer">
      <strong>
      Filling the above declaration means that you agree to provide Tutore Poland Sp. z o.o. phone number, e-mail and address for correspondence, as well as it means the declaration of compliance of the data with the legal and factual state, and awareness of criminal liability for telling untruth or concealing the truth.In case of above-mentioned data change during the term of the assignment, I undertake to inform the Principal within 7 days of the change occurring. I undertake to cover any damage resulting from a change in the content of the statements from my own resources.
      </strong>
    </p>
  </td>
</tr>

  </tbody>
  </table>
</div>

<table>
  <tr>
    <td class="polish">
      <div style="margin-top: 5px;page-break-before: always;">
        <p align="center" class="subheading"><b>Załącznik nr 5</b></p>
        <p align="center" class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
        <br>
        <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
        <ul>
          <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
          <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
          <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
          <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
          <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
        </ul>
        <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
        <ul>
          <li>Zaplanować kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
          <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
          <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
          <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
          <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
        </ul>
        <p>Czynności, które należy wykonywać podczas pracy:</p>
          <ul>
          <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
          <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
        </ul>
        <p>Czynności zabronione:</p>
        <ul>
          <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
          <li>Otwierania osłon podczas pracy urządzeń.</li>
          <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
        </ul>
        <p>Uwagi końcowe:</p>
        <ul>
          <li>
              Przy stałej pracy przy komputerze należy:
              <ul>
                  <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
                  <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
              </ul>
          </li>
        </ul>
        <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
        <div style="margin-top: 40px; font-size: 10px;">
          <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
          <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
        </div>
      </div>
    </td>

    <td class="english">
      <div style="margin-top: 5px;page-break-before: always;">
        <p class="subheading">Appendix No. 5</p>
        <p class="subheading" style="margin-bottom: 0px;"><strong>GENERAL OHS RULES FOR ADMINISTRATIVE AND OFFICE WORK</strong></p>
        <br>
        <p>Safe working conditions are ensured when:</p>
        <ul>
          <li>A sufficiently large working area is provided (at least 2m of free floor space).</li>
          <li>There is proper lighting (depending on the nature of work, min. 300lx).</li>
          <li>There is sufficient room ventilation (gravitational or mechanical); relative air humidity should not be less than 40%.</li>
          <li>There is sufficient heating in autumn and winter (min. +18°C)</li>
          <li>Hygienic and sanitary facilities are available and in good condition; also, furniture, equipment and other devices are in good repair.</li>
        </ul>
        <p>Basic steps to be taken before starting work:</p>
        <ul>
          <li>Plan the sequence of individual activities, and prepare the necessary documents and programs.</li>
          <li>Position the monitor screen against light sources to reduce glare and reflections. Check the technical condition of furniture, equipment, devices, and lighting of the workplace. Familiarise yourself with the instruction manual and the instructions for safely operating electrical and electronic equipment used while working (computer, printer, etc.). Adjust the chair accordingly and prepare the workplace.</li>
        </ul>
        <p>Things to do while working:</p>
          <ul>
          <li>Keep the workplace clean and tidy. </li>
          <li>Be careful when using electrical devices.</li>
        </ul>
        <p>Prohibited activities:</p>
        <ul>
          <li>Allowing unauthorised individuals to use the equipment.</li>
          <li>Opening the covers while the devices are operating.</li>
          <li>Using faulty or damaged devices or electrical installations (e.g. damaged insulation on wires, broken plugs or sockets, provisionally connected wires).</li>
        </ul>
        <p>Closing remarks:</p>
        <p>When permanently working at a computer, you should:</p>
        <ul>
            <li>alternately combine work related to operating a screen monitor with other types of work that do not strain the eyesight and are performed in other body - uninterrupted work using a screen monitor should not exceed one hour, or</li>
            <li>at least a 5-minute break, included in the working time, after each hour of work at the screen monitor.</li>
        </ul>
        <p style="margin-top: 30px;">I have read and acknowledged the above health and safety rules in administrative and office work.</p>
        <div style="margin-top: 40px; font-size: 10px;">
          <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
          <p style="font-size: 14px;">Contractor's signature</p>
        </div>
      </div>
    </td>
  </tr>
</table>

<div 
  v-if="zamawiajacy.includes('Ewa Szcześniewska')"
  style="page-break-before: always;"
>
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p class="subheading"><b>Appendix No. 6 A copy of the power of attorney</b></p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
        <b>Łódź, date {{ aktualnaData() }}</b>
      </p>
    </div>
  </div>
  
  <p align="center" class="subheading" style="margin-bottom: 10px;">
    <strong>
      Authorisation to represent the employer in HR matters
    </strong>
  </p>
  <p class="p-margin">
    Acting for and on behalf of Tutore Polska Sp. z o.o. seated in Łódź, we hereby authorise Ms Ewa Szcześniewska, employed as the HR Department Director, to perform the following acts on behalf of the employer:
  </p>
  <ol>
    <li>executing employment contracts;</li>
    <li>signing the so-called HR information (information on terms and conditions of employment for the employee);</li>
    <li>changing the terms and conditions of employment or pay through an agreement between the parties (an annexe to the employment contract) or a changing notice;</li>
    <li>terminating employment contracts, including submitting, on behalf of the employer, statements on termination of employment contracts and termination of contracts without notice, issuing documentation related to the termination of the employment relationship, including employment certificates;</li>
    <li>executing, amending and terminating civil law contracts;</li>
    <li>imposing disciplinary penalties;</li>
    <li>carrying out explanatory proceedings in cases related to the violation of employees' duties, the provisions of the law and instructions and regulations in force at the employer's;</li>
    <li>executing training contracts with employees;</li>
    <li>referring employees for medical examinations;</li>
    <li>entrusting employees with the employer's property with the obligation to return or account for it and, to this end, executing relevant agreements;</li>
    <li>signing certificates related to the employment relationship;</li>
    <li>receiving from employees all kinds of requests and statements related to the work process and reviewing them after consultation with the employer;</li>
    <li>entrusting employees, when so required by the employer's needs, with work other than that specified in the employment contract for a period not exceeding three months per calendar year.</li>
  </ol>
  <p class="p-margin">
    The authorisation shall be granted for an indefinite time.
  </p>
  <p class="p-margin">
    Without the employer's consent, the attorney must not transfer her powers hereunder, either in whole or part, to third parties.
  </p>
  <p>
    In performing the aforementioned activities, the attorney shall comply with the applicable legislation, including the Labour Code and the regulations issued on its basis, and the employer's internal provisions and procedures.
  </p>
  <br>
  <p><b>{{ zamawiajacy }}</b></p>
  <p><b>(Board's signatures)</b></p>
</div>

  
  </v-container>
</template>

<script>
export default {
  name: 'UmowaLektorAngielski2024',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      przedmiot1: '',
      stawka1: '',
      stawka1Slownie: '',
      przedmiot2: '',
      stawka2: '',
      stawka2Slownie: '',
      przedmiot3: '',
      stawka3: '',
      stawka3Slownie: '',
      wniosekUbezpieczenie: '',
      obywatelstwoOIZ: '',
      obywatelstwoDNI: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'NauczycielAnimatorLektor':
          shortPosition = 'NauAnimLek'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'Twórca':
          shortPosition = 'Tworca'
          break
        case 'TwórcaMateriałów':
          shortPosition = 'TMat'
          break
        case 'TwórcaFabrykaMateriałów':
          shortPosition = 'TFabMat'
          break
        case 'TwórcaMateriałówNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'MetodykTwórcaNauczyciel':
          shortPosition = 'MetTworcaNau'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    slownieAngielski(kwota) {
      switch(kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return ''
      }
    },
    slowniePokazAngielski() {
      switch(this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowyPolski () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    dataObowiazywaniaUmowyAngielski () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'the day of its conclusion'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.polish {
  width: 50%;
}

.english {
  width: 50%;
  padding-left: 18px;
}

.attachments {
  width: 100%;
}

.oswiadczenie-footer {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaLektorAngielski2024.vue